import { render } from "./CustomerPoint.vue?vue&type=template&id=7fb2b897"
import script from "./CustomerPoint.vue?vue&type=script&lang=js"
export * from "./CustomerPoint.vue?vue&type=script&lang=js"

import "./CustomerPoint.vue?vue&type=style&index=0&id=7fb2b897&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__